import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ai-screenshot"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M17.7143 17.5C18.9767 17.5 20 18.5074 20 19.75C20 20.9926 18.9767 22 17.7143 22C16.4519 22 15.4286 20.9926 15.4286 19.75C15.4286 18.5074 16.4519 17.5 17.7143 17.5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M6.28571 17.5C5.02335 17.5 4 18.5074 4 19.75C4 20.9926 5.02335 22 6.28571 22C7.54808 22 8.57143 20.9926 8.57143 19.75C8.57143 18.5074 7.54808 17.5 6.28571 17.5Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 15L21 11.5M3 15L3 3L12.5 3M15.4286 19.75C15.4286 20.9926 16.4519 22 17.7143 22C18.9767 22 20 20.9926 20 19.75C20 18.5074 18.9767 17.5 17.7143 17.5C16.4519 17.5 15.4286 18.5074 15.4286 19.75ZM16.0106 18.25L7.80952 10H7.80724L16.0106 18.25ZM8.57143 19.75C8.57143 20.9926 7.54808 22 6.28571 22C5.02335 22 4 20.9926 4 19.75C4 18.5074 5.02335 17.5 6.28571 17.5C7.54808 17.5 8.57143 18.5074 8.57143 19.75ZM7.98942 18.25L16.1905 10H16.1928L7.98942 18.25Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19.25 3L19.7697 4.23028L21 4.75L19.7697 5.26972L19.25 6.5L18.7303 5.26972L17.5 4.75L18.7303 4.23028L19.25 3Z","strokeWidth":"props.strokeWidth"}}]}]};

const AiScreenshot = Vue.extend<IconProps>({
  name: 'AiScreenshotIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'ai-screenshot',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AiScreenshot;
